import { EnvVariable } from '../../enums';
import { getStringEnvVariable } from '../../utils';

const relativeUrl = (path: string, basePath = '/messaging/api/v1'): URL => {
  return new URL(basePath.concat(path), getStringEnvVariable(EnvVariable.SERVER_HOST));
};

export const MessagingApiUrls = {
  sendEmail(): URL {
    return relativeUrl('/email');
  },
};
